import { loadingButtonClasses } from '@mui/lab'
import { buttonClasses } from '@mui/material'
import { Theme } from '@mui/material/styles'

import { layout } from '../tokens.generated'

// ----------------------------------------------------------------------
// A loading button is a button. Its height comes from the Button override and
// the indicator must never change it: the indicator is absolutely positioned,
// so all this does is put it where the icon it replaces was, at the control's
// own inset for each size rather than MUI's fixed offsets.
// ----------------------------------------------------------------------

const indicatorAt = (inset: number) => ({
  [`& .${loadingButtonClasses.loadingIndicatorStart}`]: { left: inset },
  [`& .${loadingButtonClasses.loadingIndicatorEnd}`]: { right: inset },
})

export default function LoadingButton(theme: Theme) {
  return {
    MuiLoadingButton: {
      styleOverrides: {
        root: {
          ...indicatorAt(layout.controlInset),
          [`&.${buttonClasses.sizeSmall}`]: indicatorAt(
            layout.controlInsetSmall,
          ),
          [`&.${buttonClasses.sizeLarge}`]: indicatorAt(
            layout.controlInsetLarge,
          ),
          '&.MuiButton-text': {
            '& .MuiLoadingButton-startIconPendingStart': {
              marginLeft: 0,
            },
            '& .MuiLoadingButton-endIconPendingEnd': {
              marginRight: 0,
            },
          },
        },
      },
    },
  }
}
